export var Key={ENTER:"Enter",ESCAPE:"Escape",SPACE:[" ","Spacebar"],TAB:"Tab",PERIOD:".",COMMA:","};